<template>
    <kgr-lightbox
        :value="show"
        :headline="tHeadline"
        animated
        @post-input="closeModal"
    >
        <kgr-loading
            v-show="loading"
        />
        <div
            v-show="!loading"
            class="kgr-exam-create-dialog"
        >
            <kgr-club-exam-select
                v-model="selectedExam"
                :club-id="clubId"
                :examinee-type="examineeType"
                hide-label
            />
            <hr class="kgr-separator" />
            <div class="kgr-row">
                <button
                    class="kgr-button"
                    @click="$emit('onClose')"
                >
                    {{ tButtonCancel }}
                </button>
                <button
                    class="kgr-button kgr-button--danger"
                    :value="tButtonExecute"
                    :disabled="selectedExam === null || loading"
                    @click="$emit('onCreate', selectedExam)"
                >
                    {{ tButtonExecute }}
                </button>
            </div>
        </div>
    </kgr-lightbox>
</template>

<script>
import ClubExamSelect from '../common/form/select/ClubExamSelect.vue';
import Lightbox from '../common/modal/Lightbox.vue';
import Loading from '../common/Loading.vue';

export default {
    components: {
        'kgr-lightbox': Lightbox,
        'kgr-club-exam-select': ClubExamSelect,
        'kgr-loading': Loading,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        examineeType: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            selectedExam: null,
        };
    },
    computed: {
        tHeadline() {
            return this.$t('Prüfung ablegen');
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        tButtonExecute() {
            return this.$t('Prüfung ablegen');
        },
    },
    methods: {
        closeModal() {
            this.$emit('onClose');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.kgr-exam-create-dialog {
    overflow-y: auto;
    max-height: 800px;
    padding: 2px;
}
</style>
